import React from 'react';
import memoizeOne from 'memoize-one';

const columns = memoizeOne(() => [
  {
    name: 'Nombre',
    selector: 'name',
    cell: item => <>{item.full_name}</>,
    sortable: false,
    grow: '2'
  },
  {
    name: 'Cédula de identidad (RUT)',
    selector: 'national_identification',
    sortable: false,
    grow: '1'
  },
  {
    name: 'Lugar de Prestacion de Servicios',
    selector: 'branch_office',
    sortable: false,
    grow: '1'
  }
]);

export default columns;
